import React, {useEffect, useRef, useState} from "react";
import FormikSearchSelector from 'gui/components/formikSearchSelector/FormikSearchSelector';
import {SelectOption} from 'react-select-material-ui';

export interface ISimpleSelectorProps {
  label: string;
  options: SelectOption[];
  promiseOptions?: any;
  onLoad?: any;
  field?: any;
  fakeMulti?: boolean;
}

const SimpleSelector = (props: ISimpleSelectorProps) => {
  const [loaded, setLoaded] = useState(false);
  useEffect((async () => {
    if (typeof props.onLoad === 'function') {
      try {
        await props.onLoad(props);
      } catch (e) {
      }
    }
    setLoaded(true);
  }) as any, []);
  const ref: any = useRef();
  useEffect(() => {
    if (props.options.length > 0 && ref.current && ref.current.select) {
      ref.current.select.setValue(ref.current.select.getValue());
    }
  }, [ref, props.options.length]);
  if (loaded === true && props.options.length > 0) {
    const field = {...props.field};
    if (Array.isArray(props.field.value)) {
      field.value = props.options.filter(option => props.field.value.includes(option.value));
    } else if (props.fakeMulti) {
      field.value = props.options.filter(option => props.field.value === option.value);
    }
    return (
      <FormikSearchSelector
        promiseOptions={props.promiseOptions}
        options={props.options}
        isSearchable={false}
        isClearable={false}
        {...props}
        field={field}
        selectRef={ref}
      />
    );
  }
  return null;
};


SimpleSelector.defaultProps = {
  options: []
};

export default React.memo(SimpleSelector);
